import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import FormDialog from "components/modals/FormDialog";
import MachineApprovalStatusService from "services/MachineApprovalStatus";
import MachineApprovalStatusForm from "./MachineApprovalStatusForm";
import {
  invalidateMachineApprovalStatusTableQuery,
  useMachineApprovalStatusTable,
} from "hooks/useMachineApprovalStatusTable";

export const MACHINE_APPROVAL_STATUS_TABLE_CONSTANTS = {
  tableName: "MachineApprovalStatuses",
  queryKey: "machine_approval_status",
  className: "MachineApprovalStatuses",
  header: "Machine Approval Statuses",
  headerIcon: "shop",
};

const CREATE_ACLS = [ACL_RELATIONSHIPS.MachineApprovalStatus.create];

const MachineApprovalStatusTableV3 = () => {
  const { filters, columns } = useMachineApprovalStatusTable({
    tableName: MACHINE_APPROVAL_STATUS_TABLE_CONSTANTS.tableName,
  });

  const fetchMachineApprovalStatuses = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await MachineApprovalStatusService.getTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching machine approval statuses:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={MACHINE_APPROVAL_STATUS_TABLE_CONSTANTS.headerIcon}
      header={MACHINE_APPROVAL_STATUS_TABLE_CONSTANTS.header}
      tableName={MACHINE_APPROVAL_STATUS_TABLE_CONSTANTS.tableName}
      queryKey={MACHINE_APPROVAL_STATUS_TABLE_CONSTANTS.queryKey}
      className={MACHINE_APPROVAL_STATUS_TABLE_CONSTANTS.className}
      fetchData={fetchMachineApprovalStatuses}
      createButton={
        <Authorized permissions={CREATE_ACLS}>
          <FormDialog
            FormComponent={MachineApprovalStatusForm}
            modelType="Machine Approval Status"
            onSuccess={invalidateMachineApprovalStatusTableQuery}
          />
        </Authorized>
      }
      enableSearch={false}
      enableSettings
      invalidateData={invalidateMachineApprovalStatusTableQuery}
    />
  );
};

export default MachineApprovalStatusTableV3;
